/* eslint-disable no-console */
const SUPPRESSED_CONSOLE_MESSAGES = [
  'MUI: You have provided an out-of-range value',
  'for a non-boolean attribute',
  'should be used in combination with startIcon',
];

const shouldSuppressMessage = (args: any[]): boolean => {
  const fullMessage = args.join(' ');
  return SUPPRESSED_CONSOLE_MESSAGES.some((suppressed) =>
    fullMessage.includes(suppressed),
  );
};

const originalWarn = console.warn;
const originalError = console.error;

console.warn = (...args: any[]) => {
  if (shouldSuppressMessage(args)) {
    return;
  }
  originalWarn.apply(console, args);
};

console.error = (...args: any[]) => {
  if (shouldSuppressMessage(args)) {
    return;
  }
  originalError.apply(console, args);
};
